import Immutable from 'immutable';
import { FETCH_LOGGED_IN_USER_DATA_SUCCESS } from './actions';

/*
 * This data is kept outside of the User store as it contains all the logged in profiles data
 * that doesn't fit the shape of a User (so that all objects in the User store are consistent)
 */

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function LoggedInUser(state = Immutable.Map(), action) {
  switch (action.type) {
    case FETCH_LOGGED_IN_USER_DATA_SUCCESS: {
      const { userData } = action;

      const { emailAddress, timezone } = userData;
      const myData = { emailAddress, timezone };
      return state.merge(Immutable.fromJS(myData));
    }
    default: {
      return state;
    }
  }
}
